// extracted by mini-css-extract-plugin
module.exports = {"AdminData":"_26yP6Ulk","adminDataInfoWrapper":"_1qqfm5Kt","adminDataInfoWrapperShort":"_26sTOcl9","adminDataAvatarWrapper":"_1ExIZhxI","adminDataAvatarLargeWrapper":"_17hTWHre","adminDataAvatarSmallWrapper":"_1RVcJwbm","adminDataTitle":"_1PatSjLd","adminDataTitleSmall":"_1I8qKkBv","adminName":"_1o0bmkZl","adminDataSubtitle":"_3txN2AYC","adminDataSubtitleBold":"_1CupV4ox","positionTitle":"_1O99oCcL","companyName":"_2Qay4uWr","sideTable":"_1iUYSitj"};
    if(module.hot) {
      // 1754515039693
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  